import { render } from "./ViolationConsequenciesDetail.vue?vue&type=template&id=29a0adaa"
import script from "./ViolationConsequenciesDetail.vue?vue&type=script&lang=js"
export * from "./ViolationConsequenciesDetail.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__